import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';

export function EditButton() {
  return (
    <v-btn
      color="warning"
      variant="outlined">
      Edit
    </v-btn>
  );
}

# User Roles Configuration

This is the section where you can create, edit or delete User Roles.

The defaults that come with CanvasPro are:

- **Admin** - The admin user has full permissions and control over the system
- **Network Manager** - The Network Manager role has the ability to configure the system but not the content
- **Content Manager** - The Content Manager role has the ability to configure assets, templates and channels
- **App** - The app role can only access endpoints related to apps

## Adding User Roles

Click <v-btn color='primary'>ADD</v-btn> (bottom right), this will open the **Create Custom Role** menu.

Fill this in with a Name and Description of the Role, then assign the required Permissions to this Role.

**Permissions Available:**

- Create, Read Update and Delete:

  - Assets
  - Templates
  - Channels
  - Config
  - App
  - User
  - Tag

- Restart CanvasPro
- Read Logs
- Testing

Once you've selected which permissions you would like to give this **Role** click <ExampleSaveButton text='CREATE' color='white' /> (bottom left).

## Editing User Roles

To edit a role click the <EditButton /> button underneath a role. This will bring up the **Edit Role** menu, where you can change the Role Name, Description and Permissions. Once you've made your changes click <ExampleSaveButton /> (bottom right) to save them.

## Deleting User Roles

To delete a **User Role** click the <ExampleDeleteButton variant="outlined" icon="" /> button under the role in **User Roles**. This will open a confirmation window, where you can confirm your choice. You can also delete a **User Role** in the **Edit Roles** menu by clicking the <ExampleDeleteButton color="white" /> button (bottom left).
